// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.example--text[data-v-3225a55a] {\n  letter-spacing: 1.5px;\n}\n", ""]);
// Exports
module.exports = exports;
